<template>
  <div>
    <p
      class="p1 custom-title"
      v-text="this.juridical.descriptionProduction"
    ></p>
    <div class="imagem-analytics">
      <div class="flex-container">
        <CustomLargeCard
          :amountReceivable="juridical.mainData.amountReceivable"
          :discount="juridical.mainData.discount"
          :grossValue="juridical.mainData.grossValue"
          :invoiceValue="juridical.mainData.invoiceValue"
          icon="icon_analitica.svg"
          class="mt-5 custom-large-card"
        />

        <div class="custom-div-sub-principal mt-5">
          <CustomCard
            :amountReceivable="this.juridical.backBeat"
            title="BACKBEAT"
            :isShowLink="true"
            :onDetailClick="onBackbeatDetailClick"
            :type="'backbeat'"
          />
          <CustomCard
            :amountReceivable="juridical.grosses"
            title="GLOSAS"
            :onDetailClick="onGlossesDetailClick"
            :isShowLink="this.$props.isShowLink"
            class="margin"
            :type="'gloses'"
          />
        </div>
      </div>
    </div>

    <div class="span my-5"></div>
  </div>
</template>

<script>
import CustomLargeCard from "../modal/CustomLargeCard.vue";
import CustomCard from "../modal/CustomCard.vue";
import RoutesPaths from "../../../../router/router-structure/routes-paths";
import { showBackbeat } from "../../../../services/backbeat/route-page";

export default {
  props: ["juridicalPerson", "year", "month", "isShowLink"],
  data() {
    return {
      juridical: this.$props.juridicalPerson,
    };
  },
  components: {
    CustomLargeCard,
    CustomCard,
  },
  methods: {
    onBackbeatDetailClick() {
      showBackbeat(this.$props.year, this.$props.month);
    },
    onGlossesDetailClick() {
      this.$router.push({
        path: RoutesPaths.financial.reviewGlosses(),
        query: { year: this.$props.year, month: this.$props.month },
        replace: true,
      });
    },
  },
};
</script>

<style scoped>
.margin {
  margin-top: 4.2rem;
}

.span {
  display: flex;
  width: 100%;
  height: 0.15rem;
  border-radius: 20%;
  background-color: var(--light-4);
}

.imagem-analytics {
  background-image: url("../../../../assets/images/ilus_analitica.svg");
  background-repeat: no-repeat;
  background-position: 85% 90%;
}

.flex-container {
  max-width: 70rem;
  display: grid;
  border-style: none;
  grid-column: 0;
  justify-content: center;
  align-items: center;
}

@media (min-width: 762px) {
  .flex-container {
    grid-template-columns: auto 300px;
    justify-content: initial;
    align-items: initial;
  }
}
.custom-title {
  text-align: left;
}

@media (max-width: 577px) {
  .custom-title {
    text-align: center !important;
  }
}
.custom-div-sub-principal {
  display: grid;
  justify-content: center;
  align-items: center;
}
@media (min-width: 774px) {
  .custom-div-sub-principal {
    display: grid;
    justify-content: initial;
    align-items: initial;
  }
}
.custom-large-card {
  margin-right: 0rem !important;
}
@media (min-width: 762px) {
  .custom-large-card {
    margin-right: 3rem !important;
  }
}
</style>
